module.exports = __webpack_public_path__ + "img/favorite-heart.a518907f.svg";